import { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function useSlideNavigation({ totalSlides, exitPath }) {
    const [currentSlide, setCurrentSlide] = useState(0);
    const navigate = useNavigate();

    const goNext = useCallback(() => {
        setCurrentSlide(prev => Math.min(prev + 1, totalSlides - 1));
    }, [totalSlides]);

    const goPrev = useCallback(() => {
        setCurrentSlide(prev => Math.max(prev - 1, 0));
    }, []);

    const goTo = useCallback((index) => {
        if (index >= 0 && index < totalSlides) {
            setCurrentSlide(index);
        }
    }, [totalSlides]);

    const exit = useCallback(() => {
        navigate(exitPath);
    }, [navigate, exitPath]);

    // Keyboard navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
            switch (e.key) {
                case 'ArrowRight':
                case ' ':
                    e.preventDefault();
                    goNext();
                    break;
                case 'ArrowLeft':
                    e.preventDefault();
                    goPrev();
                    break;
                case 'Escape':
                    exit();
                    break;
                default:
                    break;
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [goNext, goPrev, exit]);

    return {
        currentSlide,
        goNext,
        goPrev,
        goTo,
        exit,
        isFirst: currentSlide === 0,
        isLast: currentSlide === totalSlides - 1,
        totalSlides
    };
}
